module.exports = __webpack_public_path__ + "img/9788958283287.50e7aa39.jpg";